import { render, staticRenderFns } from "./SpecimenDeadDetails.vue?vue&type=template&id=3c25a2d8&scoped=true"
import script from "./SpecimenDeadDetails.vue?vue&type=script&lang=js"
export * from "./SpecimenDeadDetails.vue?vue&type=script&lang=js"
import style0 from "./SpecimenDeadDetails.vue?vue&type=style&index=0&id=3c25a2d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c25a2d8",
  null
  
)

export default component.exports